/*
 File: overlays.js
 Author: D McCleod
 Created: 2/28/2017
 Description: manage state of overlays for slide show
 */
const overlayLinks = $('.overlay-link:not(.social--email, .crs-utils_button)');
const overLayContainer = $('.layers-container');
const whiteoutLayer = $('.whiteoutlayer');
const closeButton = $('.close-modal');
const body = $('body');
const overlayMng = {};

overlayMng.currentModal = null;
overlayMng.data = null;
overlayMng.zoomContent = null;

overlayMng.init = function () {
    overlayLinks.bind('click', overlayMng.open);
    closeButton.bind('click', overlayMng.close);
};

overlayMng.open = function(event, ad_data){
    overlayMng.data = ad_data === undefined ? $(this).data('overlay') : ad_data;
    overlayMng.currentModal = $( '#' + overlayMng.data );

    overlayMng.zoomContent = overlayMng.currentModal.find('.modal-content');

    overLayContainer.show();
    whiteoutLayer.show();
    body.toggleClass('modal-layer-on').addClass('no-scroll');

    if (overlayMng.data === 'ss-email' || overlayMng.data === 'ss-feedback') {
        $("#js-email").show();
        $("#js-email-sent").hide();
        $("#js-feedback").show();
        $("#js-feedback-sent").hide();
        window.formsApi.clearFormFields([$("#js-email"), $("#js-feedback")]);
    }

    // when magnifying-glass icon (zoom) is clicked
    if( overlayMng.data === 'ss-imgzoom' ) {
        overlayMng.zoomContent.empty();
        overlayMng.currentModal.css('display', 'flex');
        whiteoutLayer.addClass('whiteoutlayer-image');

        overlayMng.zoomImage({
            modal: overlayMng.currentModal,
            content: overlayMng.zoomContent,
            image: $(this).siblings('.crs-slide_image'),
            caption: $(this).siblings('figcaption').html()
        });
    } else {
        overlayMng.currentModal.show();
        whiteoutLayer.removeClass('whiteoutlayer-image');
    }
};

overlayMng.close = function() {
    overlayMng.currentModal.hide();
    overLayContainer.hide();
    whiteoutLayer.hide();
    body.toggleClass('modal-layer-on').removeClass('no-scroll');
};

overlayMng.zoomImage = function(obj){
    let newSrc = obj.image.attr('src');
    let newImg = $('<img class="zoom-img">');
    // remove query string from image, if image is a gif, leav string intact
    if(newSrc.indexOf('?') === -1) {
        newSrc = newSrc;
    }
    else {
        newSrc = (newSrc.slice(0, (newSrc.search('gif') === -1? newSrc.indexOf('?') : newSrc.length) ) ||
        newSrc.slice(0, (newSrc.search('jpg') === -1 ? newSrc.indexOf('?') : newSrc.length) ) ||
        newSrc.slice(0, (newSrc.search('png') === -1 ? newSrc.indexOf('?') : newSrc.length) ));
    }
    newImg.attr('src', newSrc ).on('load', function () {
        obj.content
            .append(newImg.fadeIn())
            .append(obj.caption);
    });
};

overlayMng.getImageWidthPerc = function(img){
    // return 50% of the image width, used as captions max-width
    return img[0].width * 0.5;
};



export { overlayMng };